import { Layout } from 'antd';
import styled from 'styled-components';

// passed in collapsed prop to change margin accordingly
export const StyledLayout = styled(Layout)<{ collapsed?: boolean }>`
  height: 100%;
  transition: margin-right 0.3s ease;
  margin-right: ${({ collapsed }) => (collapsed ? '0px' : '155px')};
`;
